"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceBanner = void 0;
const react_1 = __importDefault(require("react"));
function MaintenanceBanner({ message = 'We are planning scheduled maintenance at 10PM EST. We expect it to last ~1 hour.', title = 'Scheduled Maintenance', }) {
    return (react_1.default.createElement("div", { className: "z-[1000] sticky top-0 w-full flex items-center justify-between gap-x-6 bg-cta-primary-default px-6 py-2.5 sm:pr-3.5 lg:pl-8" },
        react_1.default.createElement("p", { className: "text-sm leading-6 text-white" },
            react_1.default.createElement("a", { href: "#" },
                react_1.default.createElement("strong", { className: "font-semibold" }, title),
                react_1.default.createElement("svg", { viewBox: "0 0 2 2", className: "mx-2 inline h-0.5 w-0.5 fill-current", "aria-hidden": "true" },
                    react_1.default.createElement("circle", { cx: 1, cy: 1, r: 1 })),
                message))));
}
exports.MaintenanceBanner = MaintenanceBanner;
//# sourceMappingURL=MaintenanceBanner.js.map